/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditornodays3Inputs */

const en_menueditornodays3 = /** @type {(inputs: Menueditornodays3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a weekday above to add dishes.`)
};

const de_menueditornodays3 = /** @type {(inputs: Menueditornodays3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl oben einen Wochentag, um Gerichte einzutragen.`)
};

/**
* | output |
* | --- |
* | "Pick a weekday above to add dishes." |
*
* @param {Menueditornodays3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditornodays3 = /** @type {((inputs?: Menueditornodays3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditornodays3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditornodays3(inputs)
	return de_menueditornodays3(inputs)
});
export { menueditornodays3 as "menuEditorNoDays" }